import React, { useEffect } from "react"

import { Parallax } from "react-scroll-parallax"

import Layout from "../components/layout"
import SEO from "../components/seo"
import MarkdownContent from "../components/markdown_content"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import Image from "../components/image"

import DotSeparator from "../components/decorative/dotseparator"
import MarchingPills from "../components/decorative/marchingpills"

import PillGroupLeft from "../images/decoration/pill-group-l.svg"
// import PillGroupRight from "../images/decoration/pill-group-r.svg"

import GlossaryData from "../components/glossary_data"

const IndexPage = ({ data }) => {
  const Content = ({ slug }) => <MarkdownContent slug={slug} data={data} />

  useEffect(() => {
    document.querySelectorAll("a.term").forEach(el => {
      const term = el.getAttribute("data-term") || el.innerHTML
      const definition = GlossaryData[term]
      el.setAttribute("href", "#glossary")
      el.setAttribute("data-tooltip", definition)
      el.classList.toggle("tooltip-multiline", true)
    })
  })

  return (
    <Layout>
      <SEO title="Home" />

      <div className="wash-blue-steel-p2">
        <section id="intro" className="container padded">
          <Content slug="01-intro" />
        </section>
      </div>

      <div className="wash-white padded">
        <section id="meet-the-patients">
          <div className="container">
            <Content slug="02-00-meet-patients-intro" />
          </div>

          <div className="container padded">
            <div className="patient-impact">
              <Image name="edie" style={{ borderRadius: "50%" }} />
              <Content slug="03-01-edie" />
            </div>

            <div className="patient-impact">
              <Content slug="03-02-kevin" />
              <Image name="kevin" style={{ borderRadius: "50%" }} />
            </div>

            <div className="patient-impact">
              <Image name="hayun" style={{ borderRadius: "50%" }} />
              <Content slug="03-03-hayun" />
            </div>

            <Content slug="03-04-patients-disclaimer" />
          </div>
        </section>

        <DotSeparator />

        <section id="understanding-growth">
          <div className="container extra-padded-bottom">
            <Content slug="04-00-understanding-growth" />
          </div>
        </section>
      </div>

      <section id="why-adherence-matters">
        <div className="wash-foam">
          <MarchingPills />

          <div className="container padded-bottom">
            <Content slug="05-00-why-adherence-matters-wash" />
          </div>
        </div>

        <div className="wash-white">
          <div className="container padded">
            <Content slug="05-01-why-adherence-matters-main" />
          </div>

          <DotSeparator />
        </div>
      </section>

      <section id="barriers-to-adherence" className="wash-white">
        <div className="wash-goldenrod">
          <div className="container padded extra-margin-bottom">
            <Content slug="06-00-barriers-wash" />
          </div>
        </div>

        <Content slug="06-01-barriers-main" />

        <DotSeparator />
      </section>

      <section id="why-adherence-matters-to-providers">
        <div className="wash-foam">
          <div className="container padded">
            <Content slug="07-00-why-adherence-matters-providers-wash" />
          </div>
        </div>

        <div className="wash-white">
          <div className="container padded">
            <Content slug="07-01-why-adherence-matters-providers-main" />
          </div>

          <DotSeparator />
        </div>
      </section>

      <section id="solutions">
        <div className="wash-royal-p1">
          <div className="container padded">
            <Content slug="08-00-solutions-wash" />
          </div>
        </div>

        <div className="wash-white">
          <div className="container padded">
            <Content slug="08-01-solutions-main" />
          </div>

          <div className="container container-wider">
            <Content slug="08-02-solutions-table" />
          </div>

          <div className="container padded-bottom container">
            <Content slug="08-03-solutions-main-2" />
          </div>

          <DotSeparator />
        </div>
      </section>

      <section id="major-players">
        <div className="wash-royal">
          <div className="container padded">
            <Content slug="09-00-players-wash" />
          </div>
        </div>

        <div className="wash-white">
          <div className="container padded">
            <Content slug="09-01-players-intro" />
          </div>

          <Tabs>
            <TabList>
              <Tab>Patient Initiated</Tab>
              <Tab>Online/Delivery</Tab>
              <Tab>Retail/Delivery</Tab>
              <Tab>PBM Mail Order</Tab>
              <Tab>In-Workflow/SaaS</Tab>
            </TabList>

            <TabPanel>
              <Content slug="09-02-players-pid" />
            </TabPanel>
            <TabPanel>
              <Content slug="09-02-players-online" />
            </TabPanel>
            <TabPanel>
              <Content slug="09-02-players-retail" />
            </TabPanel>
            <TabPanel>
              <Content slug="09-02-players-mail-order" />
            </TabPanel>
            <TabPanel>
              <Content slug="09-02-players-in-workflow" />
            </TabPanel>
          </Tabs>

          <div class="container padded">
            <Content slug="09-03-players-dtc" />
          </div>

          <div class="container padded-bottom">
            <Content slug="09-04-players-dtc-table" />
          </div>

          <DotSeparator />
        </div>
      </section>

      <div className="wash-white">
        <section id="the-future">
          <div className="wash-navy">
            <div className="container padded">
              <Content slug="10-00-the-future-wash" />
            </div>
          </div>

          <div className="container padded">
            <Content slug="10-01-the-future-main" />
          </div>
          <DotSeparator />
        </section>

        <section id="conclusion">
          <div className="container">
            <Content slug="11-00-conclusion" />
          </div>
        </section>

        <DotSeparator />

        <section id="glossary">
          <div className="container">
            <Content slug="12-00-glossary" />
          </div>
        </section>

        <section id="advisory-council">
          <div className="container padded">
            <Content slug="13-00-advisory" />
          </div>
        </section>

        <section id="sources">
          <div className="container padded-bottom sources">
            <Content slug="14-00-sources" />
          </div>
        </section>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    allMarkdownRemark {
      nodes {
        html
        frontmatter {
          slug
        }
      }
    }
  }
`

export default IndexPage
